import { useTranslation } from 'react-i18next';
import { getSportsHref } from '@/helpers/variables';
import { useGetCommonStore } from '@/store';

export const useSportsRedirect = () => {
  const {
    i18n: { language },
  } = useTranslation();
  const hostname = useGetCommonStore().use.hostname();
  const sportsHref = getSportsHref(hostname, language);

  return sportsHref;
};
